import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DeleteAttachmentWarningComponent} from "../delete-attachment-warning/delete-attachment-warning.component";

@Component({
    selector: 'app-delete-evidence-file-warning',
    templateUrl: './delete-evidence-file-warning.component.html',
    styleUrls: ['./delete-evidence-file-warning.component.scss'],
    standalone: false
})
export class DeleteEvidenceFileWarningComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteAttachmentWarningComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  cancel(){
    this.dialogRef.close(false);
  }
  deleteEvidenceFile() {
    this.dialogRef.close(true);
  }

}
